import * as React from 'react';
import { setAllUtmToCookie } from "../DefaultLayout/utils/setAllUtmToCookie";
import { getCookie } from '../../utils/Cookie';

export const GetCourseWidget = ({ hash, id, frameSrc }) => {
  const initGetCourseForms = () => {
    document.querySelectorAll('div.gc-custom-form[data-hash][data-widget-id]').forEach(function (el) {
      const hash = el.getAttribute('data-hash');
      const widgetId = el.getAttribute('data-widget-id');
      const paramsFromCookies = el.getAttribute('data-params-from-cookie');

      const fullUrl = encodeURIComponent(
        [
          document.location.origin + document.location.pathname,
          [
            getCookie('gcpc') ? `gcpc=${getCookie('gcpc')}` : '',
            getCookie('utm_source') ? `utm_source=${getCookie('utm_source')}` : '',
            getCookie('utm_medium') ? `utm_medium=${getCookie('utm_medium')}` : '',
            getCookie('utm_campaign') ? `utm_campaign=${getCookie('utm_campaign')}` : '',
            getCookie('utm_term') ? `utm_term=${getCookie('utm_term')}` : '',
            getCookie('utm_content') ? `utm_content=${getCookie('utm_content')}` : '',
            getCookie('click_id') ? `clickid=${getCookie('click_id')}` : '',
            getCookie('transaction_id') ? `transaction_id=${getCookie('transaction_id')}` : '',
            getCookie('passed_gcpc') ? `passed_gcpc=${getCookie('passed_gcpc')}` : '',
          ]
            .filter(Boolean)
            .join('&'),
        ]
          .filter(Boolean)
          .join('?')
      );
      const iframe = el.firstElementChild || document.createElement('iframe');
      const paramsObj = {
        id: widgetId,
        ref: encodeURIComponent(document.referrer),
        loc: fullUrl,
        new_location: fullUrl,
        ...(paramsFromCookies ? paramsFromCookies.split(',') : []).reduce(function (obj, paramName) {
          const value = getCookie(paramName);

          if (value) obj[paramName] = value;
          return obj;
        }, {}),
      };
      const paramsStr = Object.entries(paramsObj)
        .map(([key, value]) => [key, value].join('='))
        .join('&');

      iframe.src = [frameSrc || 'https://get.advance-club.ru/pl/lite/widget/widget', paramsStr].filter(Boolean).join('?');

      const gcEmbedOnMessage = function (e) {
        const insertedIframe = document.getElementById(iframe.id);
        if (!insertedIframe) {
          return;
        }
        if (e.data.uniqName === hash) {
          if (e.data.height) {
            if (e.data.iframeName) {
              if (e.data.iframeName === iframe.name) {
                el.style.height = e.data.height + 'px';
                insertedIframe.style.height = e.data.height + 'px';
              }
            } else {
              el.style.height = e.data.height + 'px';
              insertedIframe.style.height = e.data.height + 'px';
            }
          }
        }
      };
      if (window.addEventListener) {
        window.addEventListener('message', gcEmbedOnMessage, false);
      } else if (window.attachEvent) {
        window.attachEvent('onmessage', gcEmbedOnMessage);
      } else {
        window['onmessage'] = gcEmbedOnMessage;
      }
      if (!iframe.parentNode) {
        iframe.style.width = '100%';
        iframe.style.height = '0px';
        iframe.style.border = 'none';
        iframe.style.overflow = 'hidden';
        iframe.className = Math.ceil(Math.random() * 1000);
        iframe.id = hash + '_' + iframe.className;
        iframe.name = iframe.className;
        el.appendChild(iframe);
      }
    });
  };

  React.useEffect(() => {
    setAllUtmToCookie();
    initGetCourseForms();
  }, [hash, id]);
  const paramsFromCookie = [
    'utm_source',
    'roistat_visit',
    'admitad_uid',
    'click_id',
    'keitaro',
    'gcpc',
    'utm_term',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'transaction_id',
    'passed_gcpc'
  ];

  return (
    <div
      className={'gc-custom-form'}
      data-hash={hash}
      data-widget-id={id}
      data-params-from-cookie={paramsFromCookie}
    ></div>
  );
};
